import React from "react";
import "../styles/GraduateTrainingDetails.scss";

const InternshipDetails = () => {
  return (
    <section className="space graduate-details">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-10 col-lg-11">
            <div className="graduate-card">
              <h2 className="graduate-main-title">Call for Interns!</h2>

              <p>
                Are you a continuing student seeking an internship opportunity
                to challenge yourself, grow and learn, enhance your skills, and
                gain valuable experience? Look no further, because we have the
                opportunity you are looking for!
              </p>

              <p>
                We invite applications from ambitious and motivated students
                with diverse interests and backgrounds to substantively
                contribute to and learn from our work. We value committment,
                hard-work, positivity, open-mindedness, reflection and
                willingness to learn.
              </p>

              <h3 className="graduate-section-title">Personal Specification</h3>
              <ul className="graduate-list">
                <li>Passion for reading and writing.</li>
                <li>
                  Strong attention to detail, excellent written English with a
                  particular emphasis on accurate spelling and grammar.
                </li>
                <li>
                  Excellent time management, organizational, and communications
                  skills.
                </li>
                <li>
                  General Information Technology (IT) competences and command of
                  MS office.
                </li>
                <li>
                  Strong team player, willing to lend support and assist with a
                  wider range of tasks.
                </li>
              </ul>

              <h3 className="graduate-section-title">Terms and Conditions</h3>
              <ul className="graduate-list">
                <li>
                  Internships are offered for a period of 6 months and can be a
                  maximum of 12 months.
                </li>
                <li>The standard working hours per week is 40.</li>
              </ul>

              <h3 className="graduate-section-title">Application Procedure</h3>
              <p>
                To apply, please submit a two-page CV and a motivation letter to{" "}
                <a href="mailto:recruitment@kiubunifu.com">
                  recruitment@kiubunifu.com
                </a>
                . In your motivation letter, indicate your preferred area of
                interest and availability period. Incomplete applications will
                not be considered.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InternshipDetails;
